import React from "react";
import {
  HowWeCanHelpBannerContainer,
  HowWeCanHelpBannerParagraph,
  HowWeCanHelpBannerParagraphHeader,
  HowWeCanHelpBannerParagraphText,
  HowWeCanHelpBannerImage,
  HowWeCanHelpBannerParagraphActions,
  Bold,
} from "./HowWeCanHelpBanner.styled";
import SubSectionText from "components/SubSectionText/SubSectionText";
//import Image from "components/Image/Image";
import { Trans } from "react-i18next";

import imgBanner from "assets/images/jpg/How We Can Help/how-we-can-help-banner.jpg";
import ActionButton from "components/Button/ActionButton/ActionButton";
import { ReactComponent as ButtonIcon } from "assets/images/svg/arrow-up-right-black.svg";
import useDevice from "hooks/useDevice";
import { PAGES } from "constants/pages";

const HowWeCanHelpBanner = () => {
  const { isMobile } = useDevice();
  const paddingBottom = isMobile ? "35px" : "auto";
  return (
    <HowWeCanHelpBannerContainer>
      <HowWeCanHelpBannerParagraph>
        <HowWeCanHelpBannerParagraphHeader>
          <Trans
            i18nKey="howWeCanHelpPage.intro.header"
            components={[<Bold key={0} />]}
          />
        </HowWeCanHelpBannerParagraphHeader>
        <HowWeCanHelpBannerParagraphText>
          <SubSectionText
            text={"howWeCanHelpPage.intro.text"}
            textColor={"dark"}
          />
        </HowWeCanHelpBannerParagraphText>
        <HowWeCanHelpBannerParagraphActions sx={{ pb: paddingBottom }}>
          <ActionButton
            size={"lg"}
            isLink={true}
            marginTop={"0px"}
            maxWidth={"auto"}
            font={!isMobile ? "24px" : "13px"}
            padding={!isMobile ? "38px 24px" : "21px 24px"}
            iconSize={"9.5px"}
          >
            <Trans i18nKey="howWeCanHelpPage.intro.hireUs" />
            <ButtonIcon></ButtonIcon>
          </ActionButton>
          <ActionButton
            size={"lg"}
            marginTop={"0px"}
            maxWidth={"auto"}
            color="dark"
            padding={!isMobile ? "38px 32px" : "21px 24px"}
            to={PAGES.CASE_STUDIES.route}
            font={!isMobile ? "24px" : "13px"}
            iconSize={"9.5px"}
          >
            <Trans i18nKey="howWeCanHelpPage.intro.ourWork" />
            <ButtonIcon></ButtonIcon>
          </ActionButton>
        </HowWeCanHelpBannerParagraphActions>
      </HowWeCanHelpBannerParagraph>
      <HowWeCanHelpBannerImage src={imgBanner}></HowWeCanHelpBannerImage>
    </HowWeCanHelpBannerContainer>
  );
};

export default HowWeCanHelpBanner;
